<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { required } from "vuelidate/lib/validators";
// import DatePicker from "vue2-datepicker";
import DatePicker from 'vuejs-datepicker';
import axios from "axios";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import moment from "moment";
import Vuetable from "vuetable-2";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import Loader from "@/components/widgets/loader";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
// import MaskedInput from "vue-text-mask";
import Vue from "vue";
import { FulfillingBouncingCircleSpinner } from "epic-spinners";
Vue.component("v-select", vSelect);
// register the plugin on vue
import Toasted from "vue-toasted";

import { es} from 'vuejs-datepicker/dist/locale';
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";

Vue.use(Toasted);
/**
 * new orden component
 */
export default {
  page: {
    title: "Nueva Asignacion de Alimento  ",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Vuetable,
    VuetablePagination,
    DatePicker,
    Loader,
    "fulfilling-bouncing-circle-spinner": FulfillingBouncingCircleSpinner,
    // "masked-input": MaskedInput,
  },
  data() {
    return {
      disabledDates: {
          to: '',
      },
      es: es,
      arrayConcentrado:[],
      arrayLote:[],
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      apiBase:
        process.env.VUE_APP_URL +  "lotes/get",
      saldo: 0,
      // Variables para metodos de pago
      cantidad_efectivo: "",
   
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
        },
        pagination: {
          infoClass: "pull-left",
          wrapperClass: "vuetable-pagination pull-right",
          activeClass: "btn-primary",
          disabledClass: "disabled",
          pageClass: "btn btn-border",
          linkClass: "btn btn-border",
          icons: {
            first: "",
            prev: "",
            next: "",
            last: "",
          },
        },
      },
      // variables para detalle
      cabezera: [
      { key: 'index', label: 'Índice' },
        { key: "no_lote", label: "No. Lote", thClass: "cell1" },
        { key: "no_animales", label: "No. Animales", thClass: "cell1" },
        { key: "fecha_inicio", label: "Fecha Inicio", thClass: "cell1" },
        { key: "fecha_fin", label: "Fecha Fin", thClass: "cell1" },
        { key: "tipo_lote", label: "Tipo Lote", thClass: "cell1" },
        { key: "cantidad_sugerida", label: "Cantidad Sugerida", thClass: "cell1" },
      ],
      apiUrl: process.env.VUE_APP_URL,
      fieldsBusqueda: [{
            name: "actions",
            title: "Acciones",
            titleClass: "",
            width: "10%",
            },
            {
            name: "no_lote",
            title: "No. Lote",
            sortField: "no_lote",
            width: "20%",
            },
            {
            name: "no_animales",
            title: "No. Animales",
            sortField: "no_animales",
            width: "20%",
            },
            {
            name: "fecha_inicio",
            title: "Fecha Inicio",
            sortField: "fecha_inicio",
            width: "20%",
            },
            {
            name: "tipo_lote",
            title: "Tipo Lote",
            sortField: "tipo_lote",
            width: "20%",
            },
        ],
      fields: [
        {
          name: "actions",
          title: "Acciones",
          titleClass: "",
          width: "10%",
        },
        {
          name: "codigo",
          title: "Código",
          sortField: "codigo",
          width: "20%",
        },
        {
          name: "raza",
          title: "Raza",
          sortField: "raza",
          width: "20%",
        },
        {
          name: "fecha_ingreso",
          title: "Fecha Ingreso",
          sortField: "fecha_ingreso",
          width: "20%",
        },
        {
          name: "no_partos",
          title: "Fecha Ingreso",
          sortField: "no_partos",
          width: "20%",
        },
      ],
      formPro: {
        fecha_limite: new Date(),
        concentradoid: -1,
        metodo_pago: "0",
        
        factura: "",
        fecha_inicio: new Date(),
        fecha_fin: new Date(),
        tiendaid: "",
        tienda: "",
        orden: "",
        concentrado: "",
        total: "",
        state: true,
        observaciones : "",
        id: 0,
      },
      data: [
        {
          nombre: "",
          cantidad: "",
          precio_compra: "",
          precio_venta: "",
          subtotal: "",
          ubicacion: "",
          sub_presentacion: "",
          button: true,
        },
      ],
      title: "Nueva Asignanción de Alimento",
      items: [
        {
          text: "Corrales",
          href: "/",
        },
        {
          text: "Corrales",
          active: true,
        },
      ],
      searchType: [
        { nombre: "No. Lote", value: "no_lote" },
        // { nombre: "Codigo", value: "codigo" },
      ],
      options: {
        theme: "outline",
        position: "top-right",
        duration: 5000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },
      mask_quetzal: createNumberMask({
        prefix: "Q ",
        suffix: "",
        includeThousandsSeparator: true,
        thousandsSeparatorSymbol: ",",
        allowDecimal: true,
        decimalSymbol: ".",
        decimalLimit: 2, // how many digits allowed after the decimal
        integerLimit: 10, // limit length of integer numbers
        allowNegative: false,
        allowLeadingZeroes: false,
      }),
      loadingtable: false,
      sortBy: "no_lote",
      sortDesc: false,
      searchLabel: { nombre: "No. Lote", value: "no_lote" },
      showModalL: false, //Loading
      showModalE: false, //Editar
      showModalN: false, //Nuevo registro
      showModalD: false, //Desactivar
      showModalA: false, //Activar
      pageOptions: [4, 10, 15, 20],
      search: "",
      page: 1,
      perPage: 20,
      from: 0,
      to: 0,
      total: 0,
      lastPage: 0,
      arrayDetalle: [],
      LotesExist:'',
      totalAnimalesActuales: 0,
      banderaComida: false,
    };
  },
  validations: {
    formPro: {
      concentrado: { required },
      factura: { required },
      fecha_inicio: { required },
      fecha_fin: { required },
      tienda: { required },
      orden: { required },
      total: { required },
    },
    arrayDetalle: {
      required,
      $each: {
        cantidad: {
          required,
        },
        ubicacion: {
          required,
        },
      },
    },
    data: { required },

  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    calcularTotal: function () {
      

      return this.arrayDetalle.length + parseInt( this.totalAnimalesActuales );
    },
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    // PROVEEDORES
    // Función para las fechas de búsqueda
    beetween(date1,date2){
        var dt1 = new Date(date1);
        var dt2 = new Date(date2);
        // console.log(Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate())/(1000 * 60 * 60 * 24));
        return Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate()) ) /(1000 * 60 * 60 * 24));
    },
    updateDisableDates(){
        let me = this;
        if(new Date(me.customFormatter(me.formPro.fecha_inicio)).getTime() > new Date(me.customFormatter(me.formPro.fecha_fin))){
            me.$refs.myDatepicker.clearDate();
            me.formPro.fecha_fin = '';
            me.arrayDetalle = [];
        }
        me.disabledDates.to = new Date(me.formPro.fecha_inicio);
        // me.arrayDetalle = [];
    },
    changeDate(){
        let me = this;
        me.arrayDetalle = [];
    },
    getDatosConcentrado(val1){
        let me = this;
        me.loading = true;
        if (val1 == null || val1 == ''){
            me.formPro.concentrado = '';
            me.formPro.concentradoid = -1;
        }
        else {
            me.formPro.concentradoid = val1.id;
            me.arrayDetalle=[];

        }
    },
    selectConcentrado(search, loading){
                let me = this;
                loading(true);
                let url =  process.env.VUE_APP_URL + '/concentrado/select?search=' + search;
                axios.get(url,{
                    headers: { "x-token": this.userT.token },
                }).then(function (response) {
                    // console.log(response);
                    me.arrayConcentrado = response.data.data.data;
                    loading(false);
                })
                .catch(function (error) {
                    console.log({error});
                });
    },
    tomandototal() {
      let temp = 0;
      temp = parseFloat(this.calcularTotal);
      this.formPro.total = temp;
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    //Validaciones antes de guardar
    validaciones() {
      // stop here if form is invalid
      this.$v.$touch();
      // console.log(this.formPro.proveedor);
      console.log(this.formPro.concentradoid);
      if (
        this.formPro.concentradoid <=0
      ) {
        // console.log("retroll");
        Vue.toasted.error("Revise la cabecera de la asignancio ", this.options);
        return;
      } 
      else if(this.arrayDetalle.length <=0){
        Vue.toasted.error("Agregue Detalles a la asignancio ", this.options);
        return;
      }
      
      else {
  
          this.save();
        }
      
    },
    async validaFecha(idlote) {
      const {
        concentradoid
      } = this.formPro;
      try{
        const respuesta = await axios
        .post(
          process.env.VUE_APP_URL + "asignacion_alimento/validacionFecha",
          {
            fecha_inicio : this.customFormatter(this.formPro.fecha_inicio),
            fecha_fin : this.customFormatter(this.formPro.fecha_fin),
            concentradoId : concentradoid,
            idlote
          },
          {
            headers: { "x-token": this.userT.token },
          }
        );

        return respuesta.data.data;
      }catch(error){
        console.error("Error!", error);
        Vue.toasted.error("Error para guardar", this.options);
      }
        
    },
    //Guardar registro
    async save() {
      const {
        concentradoid
      } = this.formPro;
      const me = this;
      this.showModalL = true;

      axios
        .post(
          process.env.VUE_APP_URL + "asignacion_alimento/store",
          {
            cantidad : this.beetween(this.customFormatter(this.formPro.fecha_inicio), this.customFormatter(this.formPro.fecha_fin))+1,
            fecha_inicio : this.customFormatter(this.formPro.fecha_inicio),
            fecha_fin : this.customFormatter(this.formPro.fecha_fin),
            concentradoId : concentradoid,
            userId: this.userT.id,
            alimentos : me.arrayDetalle,
          },
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then(() => {
          Vue.toasted.success("Registro Guardado", this.options);
          this.showModalN = false;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
          Vue.toasted.error("Error para guardar", this.options);
        })
        .finally(() => {
          this.showModalL = false;
          this.$router.push({
            name: "AsignacionAlimento",
            shallow: true,
          });
        });
    },
    // Funciones para trabajar con detalles

    converMaskToNumberxd(number) {
      var myNumber = "";
      for (var i = 0; i < number.length; i += 1) {
        if (
          number.charAt(i) === "Q" ||
          number.charAt(i) === "€" ||
          number.charAt(i) === "$" ||
          number.charAt(i) === "%" ||
          number.charAt(i) === "," ||
          number.charAt(i) === " "
        ) {
          continue;
        } else {
          myNumber += number.charAt(i);
        }
      }
      return parseFloat(myNumber).toFixed(2);
    },
    // Funciones para formatos
   
    formatQuetzales(amount) {
      let num = parseFloat(amount),
        formatted;
      formatted = num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
      return (amount = "Q " + formatted);
    },
  
    // FUNCIONES AUXILIARES
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    eliminarDetalle(index) {
      this.arrayDetalle.splice(index, 1);
    },
    async agregarDetalle(data) {
      // console.log(data);
      const {id, no_lote, no_animales,  tipo_lote} = data

      const me = this;
      if(me.encuentra(id)){
            Vue.toasted.error("El producto seleccionado ya se encuentra en el detalle", this.options);
          }else{
            if(this.formPro.concentradoid <= 0){
              Vue.toasted.error("Debe seleccionar un concentrado", this.options);
              return;
            }
            else if (this.formPro.fecha_inicio == '' || this.formPro.fecha_fin == ''){
              Vue.toasted.error("Debe seleccionar una fecha de inicio y fin", this.options);
              return;
            }
            else{
              const bandera = await me.validaFecha(id);
              if(bandera){
                Vue.toasted.error("El lote seleccionado ya tiene una asignación de alimento en el rango de fechas seleccionado", this.options);
                return;
              }
              else if (data.no_animales <= 0){
                Vue.toasted.error("El lote seleccionado no tiene animales", this.options);
                return;
              }
              else{
                // console.log(this.customFormatter(this.formPro.fecha_inicio)
              me.arrayDetalle.push({
                id, no_lote, no_animales, fecha_inicio : this.customFormatter(this.formPro.fecha_inicio), fecha_fin :
                this.customFormatter( this.formPro.fecha_fin), tipo_lote, cantidad_sugerida : 0
             
              });
              }
            }
            
          } 
    },
    verificaAnimal(stock) {
      const me = this;
      // console.log(stock)
      if (me.encuentra(stock["id"].toString())) {
        return true;
      }
    },
    // Esta función encuentra si en el detatalle ya esta la habitacion
    encuentra(id) {
      let sw = 0;
      for (var i = 0; i < this.arrayDetalle.length; i++) {
        if (this.arrayDetalle[i].id.toString() == id) {
          sw = true;
        }
      }
      return sw;
    },


    //Buscador dentro de la tabala
    onFiltered() {
      this.search = this.search.toLowerCase();
      this.$refs.vuetable.refresh();
    },
    //enviar datos a la Paginacion
    onPaginationData(paginationData) {
      this.to = paginationData.to;
      this.total = paginationData.total;
      this.lastPage = paginationData.last_page;
      this.items = paginationData.data;
      this.$refs.pagination.setPaginationData(paginationData);
      // console.log(paginationData);
    },
    //Cambiar tamaño de filas en la tabala para mostrar
    changePageSize() {
      this.$refs.vuetable.refresh();
    },

    // Cambiar el valor del dropwdown para poder filtrar
    changeTypeSearch(type) {
      this.searchLabel = type;
      this.$refs.vuetable.refresh();
    },
    //Cuando cambia de pagina
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    //Query para realizar busquedas y ordenar
    makeQueryParams(sortOrder, currentPage) {
      return sortOrder[0]
        ? {
            criterio: sortOrder[0]
              ? sortOrder[0].sortField
              : this.searchLabel.value,
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
            tienda :  this.userT.tienda,
          }
        : {
            criterio: sortOrder[0]
              ? sortOrder[0].sortField
              : this.searchLabel.value,
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
            tienda :  this.userT.tienda,
          };
    },
  },
};
</script>

<template>
  <Layout>
    <b-modal
      centered
      v-model="showModalL"
      title-class="text-black font-18"
      body-class="p-3"
      hide-footer
      no-close-on-backdrop
      content-class="my-class"
      header-class="my-class"
    >
      <template #modal-header="{}">
        <!-- Emulate built in modal header close button action -->

        <h5></h5>
      </template>
      <form>
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-center">
              <fulfilling-bouncing-circle-spinner
                :animation-duration="2000"
                :size="90"
                color="#2a3042"
              />
            </div>
          </div>
        </div>
      </form>
    </b-modal>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="pt-3">
              <div class="row">
                <div class="col-">
                  <div class="cabecera-container">
                  <div class="titulo-seccion">
                    <h4>Datos Generales</h4>
                  </div>
                  <div class="boton-regresar">
                    <router-link :to="{ name: 'AsignacionAlimento' }">
                      <b-button variant="outline-primary" type="button" class="btn-rounded">
                        <i class="mdi mdi-arrow-collapse-left"></i> Regresar
                      </b-button>
                    </router-link>
                  </div>
                </div>

                <div class="datos-generales-container">
  
  <div class="inputs-container">
    <div class="input-item">
      <p class="input-label">Concentrado</p>
      <v-select
        v-model.trim="$v.formPro.concentrado.$model"
        :state="!$v.formPro.concentrado.$error"
        :options="arrayConcentrado"
        @search="selectConcentrado"
        @input="getDatosConcentrado"
        placeholder="Buscar Concentrado..."
        label="nombre_producto"
      ></v-select>
      <div class="invalid-feedback"
           v-if="$v.formPro.concentrado.$error && !$v.formPro.concentrado.required">
        Debe seleccionar un Alimento
      </div>
    </div>

    <div class="input-item">
      <p class="input-label">Fecha Inicio</p>
      <date-picker
        v-model.trim="$v.formPro.fecha_inicio.$model"
        :state="!$v.formPro.fecha_inicio.$error"
        :first-day-of-week="1"
        :bootstrap-styling="true"
        :selected="updateDisableDates()"
        :language="es"
        :format="customFormatter"
      ></date-picker>
      <div class="invalid-feedback"
           v-if="$v.formPro.fecha_inicio.$error && !$v.formPro.fecha_inicio.required">
        Debe ingresar una fecha
      </div>
    </div>

    <div class="input-item">
      <p class="input-label">Fecha Límite</p>
      <date-picker
        :bootstrap-styling="true"
        v-model.trim="$v.formPro.fecha_fin.$model"
        :state="!$v.formPro.fecha_fin.$error"
        :first-day-of-week="1"
        ref="myDatepicker"
        @input="changeDate"
        :disabledDates="disabledDates"
        :language="es"
        :format="customFormatter"
      ></date-picker>
      <div class="invalid-feedback"
           v-if="$v.formPro.fecha_fin.$error && !$v.formPro.fecha_fin.required">
        Debe ingresar una fecha límite
      </div>
    </div>
  </div>
</div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <Loader :loading="loadingtable">
      <b-tabs
        justified
        nav-class="nav-tabs-custom"
        content-class="p-3 text-muted"
      >
      <b-tab active>
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <h5><i class="bx bxs-folder-plus"></i></h5>
          </span>
          <h5>
            <span class="d-none d-sm-inline-block">
              <i class="bx bxs-folder-plus"></i>Seleccionar Lotes</span
            >
          </h5>
        </template>
        <div class="tabla-contenedor">
  <div class="filtros-container">
    <div class="filtro-item">
      <label>Mostrar</label>
      <b-form-select
        v-model="perPage"
        @input="changePageSize()"
        :options="pageOptions"
        size="sm"
      ></b-form-select>
    </div>
    <div class="filtro-item">
      <b-dropdown v-if="searchType" size="sm">
        <template v-slot:button-content>
          {{ "Buscar por: " + searchLabel.nombre }}
          <i class="mdi mdi-chevron-down"></i>
        </template>
        <b-dropdown-item
          v-for="(search, index) in searchType"
          :key="index"
          @click="changeTypeSearch(search)"
          >{{ search.nombre }}</b-dropdown-item
        >
      </b-dropdown>
    </div>
    <div class="filtro-item">
      <b-form-input
        v-model="search"
        type="search"
        @input="onFiltered()"
        placeholder="Buscar..."
        class="input-buscar"
      ></b-form-input>
    </div>
  </div>
  <vuetable
    small
    striped
    ref="vuetable"
    class="table-responsive order-with-arrow tabla-principal"
    :css="css.table"
    :http-options="httpOptions"
    :api-url="apiBase"
    :reactive-api-url="true"
    :fields="fieldsBusqueda"
    :per-page="perPage"
    :query-params="makeQueryParams"
    pagination-path
    @vuetable:pagination-data="onPaginationData"
  >
    <div slot="actions" slot-scope="props" v-if="verificaAnimal(props.rowData) != true">
      <b-button
        tabindex="0"
        v-b-tooltip.focus
        title="Agregar"
        variant="outline-primary"
        @click="agregarDetalle(props.rowData)"
        ><i class="bx bx-check"></i
      ></b-button>
    </div>
  </vuetable>
  <vuetable-pagination
    ref="pagination"
    :css="css.pagination"
    @vuetable-pagination:change-page="onChangePage"
  ></vuetable-pagination>
</div>

      </b-tab>
        <b-tab>
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <h5><i class="bx bxs-food-menu"></i></h5>
            </span>
            <h5>
              <span class="d-none d-sm-inline-block">
                <i class="bx bxs-food-menu"></i>Asignar detalles</span
              >
            </h5>
          </template>
          <b-table
  small
  striped
  responsive
  v-if="arrayDetalle.length > 0"
  ref="table"
  :items="arrayDetalle"
  :fields="cabezera"
  class="tabla-detalles-asignados"
>
  <template #cell(index)="data">
    <b-button
  variant="outline-danger"
  @click="eliminarDetalle(data.index)"
  class="boton-eliminar"
>
  <i :class="'bx bx-trash'"></i>
</b-button>

  </template>
  <template #cell(codigo)="data">
    {{ data.item.codigo }}
  </template>
  <template #cell(raza)="data">
    {{ data.item.raza }}
  </template>
  <template #cell(fecha_ingreso)="data">
    {{ data.item.fecha_ingreso }}
  </template>
  <template #cell(partos)="data">
    {{ data.item.partos }}
  </template>
  <template #cell(cantidad_sugerida)="data">
    <input
      type="number"
      class="form-control input-cantidad-sugerida"
      v-model="data.item.cantidad_sugerida"
    />
  </template>
</b-table>

        </b-tab>
      </b-tabs>

      <div class="col-sm-12 pt-3">
        <div class="row">
          <div class="col">
            <router-link
              class="d-grid gap-2"
              :to="{
                name: 'AsignacionAlimento',
              }"
            >
              <b-button
                block
                size="lg"
                variant="outline-primary"
                type="button"
                class="btn btn-rounded mb-2 me-2"
              >
                <i class="bx bx-arrow-back"></i>&nbsp;&nbsp;<b>REGRESAR</b>
              </b-button>
            </router-link>
          </div>
          <div class="col d-grid gap-2">
            <b-button
              block
              size="lg"
              variant="outline-success"
              class="btn btn-rounded mb-2 me-2"
              @click="validaciones('save')"
            >
              {{ tomandototal() }}
              <i class="mdi mdi-truck-fast me-1"></i>
              &nbsp;&nbsp;<b>GUARDAR</b>
            </b-button>
          </div>
        </div>
      </div>
    </Loader>
    <!-- end row -->
  </Layout>
</template>

<style scoped>
.cabecera-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid #e0e0e0;
}

.titulo-seccion h4 {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
  color: #333;
}

.boton-regresar b-button {
  font-size: 0.9rem;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  border: 1px solid #007bff;
  color: #007bff;
  background: transparent;
}

.boton-regresar b-button:hover {
  background: #007bff;
  color: #fff;
}
.datos-generales-container {
  padding: 2rem 1.5rem;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);
  margin-bottom: 2rem;
}

.inputs-container {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  margin-top: 1rem;
}

.input-item {
  flex: 1 1 30%;
  min-width: 200px;
}

.input-label {
  font-weight: 500;
  margin-bottom: 0.5rem;
  color: #555;
}

.v-select, .date-picker {
  width: 100%;
}

.invalid-feedback {
  color: #e74c3c;
  font-size: 0.875rem;
  margin-top: 0.25rem;
}
@media (max-width: 1024px) {
  .datos-generales-container {
    padding: 1.5rem 1rem;
    margin-bottom: 1.5rem;
  }

  .inputs-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .input-item {
    flex: 1 1 auto;
    width: 100%;
    min-width: auto;
  }

  .boton-regresar {
    text-align: center;
    margin-top: 1rem;
  }

  .boton-regresar b-button {
    width: 100%;
    padding: 0.75rem 1rem;
    border-radius: 15px;
  }

  .titulo-seccion h4 {
    text-align: center;
    font-size: 1.3rem;
  }
}

@media (max-width: 768px) {
  .datos-generales-container {
    padding: 1rem;
  }

  .titulo-seccion h4 {
    font-size: 1.2rem;
  }

  .input-item {
    margin-bottom: 1rem;
  }
}

.tabla-contenedor {
  padding: 1.5rem 1rem;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);
  margin-bottom: 2rem;
}
.filtros-container {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1rem;
}

.filtro-item {
  flex: 1 1 100%;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.input-buscar {
  width: 100%;
}

.tabla-principal {
  width: 100%;
  overflow-x: auto;
}

.vuetable th, .vuetable td {
  padding: 0.75rem;
  font-size: 0.9rem;
}

.b-button-group {
  padding: 0;
}

.b-button {
  padding: 0.25rem 0.5rem;
  font-size: 0.85rem;
}
@media (max-width: 1024px) {
  .filtros-container {
    flex-direction: column;
    gap: 0.75rem;
    align-items: center;
  }

  .filtro-item {
    flex: 1 1 100%;
    text-align: center;
  }

  .vuetable {
    font-size: 1rem;
  }

  .vuetable th, .vuetable td {
    padding: 0.75rem;
    text-align: center;
  }

  .vuetable-pagination {
    text-align: center;
    margin-top: 1rem;
  }

  .b-button {
    padding: 0.4rem 0.6rem;
    font-size: 0.9rem;
  }

  .input-buscar {
    max-width: 80%;
  }

  .filtros-container label {
    font-size: 1rem;
  }
}

@media (max-width: 768px) {
  .filtros-container {
    gap: 0.5rem;
  }

  .tabla-principal {
    font-size: 0.9rem;
  }

  .vuetable th, .vuetable td {
    padding: 0.5rem;
  }

  .b-button {
    padding: 0.3rem 0.5rem;
    font-size: 0.85rem;
  }
}

.tabla-detalles-asignados {
  width: 100%;
  margin-top: 1rem;
  overflow-x: auto;
}

.tabla-detalles-asignados th,
.tabla-detalles-asignados td {
  padding: 0.75rem;
  text-align: center;
  font-size: 0.9rem;
}.boton-eliminar {
  padding: 0.6rem 0.8rem;
  font-size: 1rem;
  border-radius: 50%;
  border: 1px solid #d9534f; /* Un tono más suave */
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s, color 0.3s, border-color 0.3s;
}

.boton-eliminar:hover {
  background-color: #d9534f;
  color: #fff;
  border-color: #c9302c; /* Tono más oscuro al hacer hover */
}


.input-cantidad-sugerida:focus {
  outline: none;
  box-shadow: 0 0 5px rgba(41, 128, 185, 0.6);
  border-color: #2980b9; /* Un tono de azul suave */
}

.tabla-detalles-asignados th,
.tabla-detalles-asignados td {
  padding: 1rem;
  text-align: center;
  font-size: 1rem;
}

.input-cantidad-sugerida {
  width: 90%;
  margin: 0 auto;
  text-align: center;
  font-size: 1rem;
  padding: 0.5rem;
}

@media (max-width: 1024px) {
  .boton-eliminar {
    padding: 0.45rem 0.6rem;
    font-size: 0.85rem;
  }

  .tabla-detalles-asignados th,
  .tabla-detalles-asignados td {
    padding: 0.85rem;
    font-size: 0.95rem;
  }

  .input-cantidad-sugerida {
    width: 100%;
    font-size: 0.95rem;
  }
}


</style>
